<template>
  <div
    class="bonusProgress text-white"
    :class="{'bonusProgress-active': ['COMPLETE', 'RECONNECT'].includes(status)}">
    <div class="bonusProgress_coin">
      <a
        v-if="['CLOSE', 'FAKE','NEXT'].includes(status)"
        class="absolute-full z-top"
        href="javascript:;"
        @click="coinClickHander"></a>
      <img
        :src="require(`../../../assets/images/xbb/${coinImg}`)"
        class="bonusProgress_coin_img absolute-center">
      <progress-ring
        v-show="['PLAY', 'FAKE'].includes(status)"
        color="#FFD6A6"
        :radius="15"
        :progress="progress"
        :stroke="stroke">
        <span
          v-show="status === 'PLAY'"
          class="bonusProgress_coin_times absolute-center">{{ times }}</span>
      </progress-ring>
    </div>
    <div
      v-show="status === 'COMPLETE'"
      class="bonusProgress_amount">
      +{{ amount }} 元
    </div>
    <div
      v-show="status === 'RECONNECT'"
      class="bonusProgress_reconnect">
      连线中...
    </div>
  </div>
</template>

<script>
import ProgressRing from './ProgressRing'
const statusIcon = {
  PLAY: 'bonus_coin_bg.png',
  COMPLETE: 'bonus_coin_active.png',
  CLOSE: 'bonus_coin_wait.png',
  RECONNECT: 'bonus_coin_reconnect.png',
  FAKE: 'bonus_coin_solid.png',
  NEXT: 'bonus_coin_next.png'
}

export default {
  name: 'bonusProgress',
  components: {
    ProgressRing
  },
  props: {
    status: {
      type: String,
      default: 'PLAY',
      validator: (value) => ['PLAY', 'COMPLETE', 'CLOSE', 'RECONNECT', 'FAKE', 'NEXT'].indexOf(value) !== -1
    },
    progress: {
      type: Number,
      default: 0
    },
    times: {
      type: Number,
      default: 0
    },
    amount: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      img: 'bg'
    }
  },
  computed: {
    coinImg () {
      return statusIcon[this.status]
    },
    stroke () {
      return this.progress === 0 ? 2 : 2
    }
  },
  methods: {
    coinClickHander () {
      this.$emit('open-dialog')
    }
  }
}
</script>

<style scoped>
.bg-bonus {
  background: #ffd628;
}

.bonusProgress {
  display: flex;
  width: 30px;
  height: 30px;
  padding-left: 2px;
  font-size: 15px;
  line-height: 30px;
  background-color: #444;
  border-radius: 14px 0 0 15px;
  opacity: 0.8;
  transition: width 0.3s;
}

.bonusProgress_coin {
  position: relative;
  width: 30px;
  height: 100%;
}

.bonusProgress_coin_img {
  width: 16px;
  height: 16px;
}

.bonusProgress_coin_progress {
  color: #ffd628;
}

.bonusProgress_coin_times {
  color: #fff07b;
}

.bonusProgress_amount {
  margin-left: 5px;
  overflow: hidden;
  font-weight: 700;
  color: #ff7f00;
}

.bonusProgress_reconnect {
  margin-left: 5px;
  overflow: hidden;
  font-size: 14px;
  color: #ffd628;
}

.bonusProgress-active {
  width: 105px;
}

.text-white {
  color: #fff;
}

.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.absolute-full {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.z-top {
  z-index: 7000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusProgress.vue